// removed by extract-text-webpack-plugin
module.exports = {"TimerContainer":"styles__TimerContainer___2rtrW","Resend":"styles__Resend___2kw8T"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/Login/Form/Timer/styles.scss
// module id = 1495
// module chunks = 0